import http from "../../../http-common";
import getErrorMessage from "../../../util";

const get_data = (object_key) => {
  return http.get(`/v1/get_blob_data/${object_key}`);
};

export const get_shared_chart_data = async (object_key) => {
  try {
    const uploader_response = await get_data(object_key);
    const response_data = uploader_response.data;
    const { data } = response_data;
    const { columns, table_data, paginated_data, paginated_data_copy, formatted_json_data, status, selected_secondary_names_chart_view } = data;
    const [primary_filter_key, secondary_filter_key] = Object.keys(selected_secondary_names_chart_view);
    const result = { columns, table_data, paginated_data, paginated_data_copy, formatted_json_data, status, selected_secondary_names_chart_view, primary_filter_key, secondary_filter_key };
    return {
      result,
      error: false
    };
  } catch (error) {
    const err = getErrorMessage(error);
    return {
      error: err,
      result: null
    };
  }
};